export default __webpack_public_path__ + "static/media/mentor_mock_2.abd515d3.png";